/* RESPONSIBLE TEAM: team-automation-foundations */

import StepSerializer from '../step';

export default StepSerializer;
